import { render, staticRenderFns } from "./FreeMediaBenefit.vue?vue&type=template&id=6776cc24&scoped=true&"
import script from "./FreeMediaBenefit.vue?vue&type=script&lang=js&"
export * from "./FreeMediaBenefit.vue?vue&type=script&lang=js&"
import style0 from "./FreeMediaBenefit.vue?vue&type=style&index=0&id=6776cc24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6776cc24",
  null
  
)

export default component.exports